import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const ProgressDonutChart = ({
  percentage = 0,
  size = 120,
  color = '#2D86B4',
  backgroundColor = '#D3DFEA',
  label = '',
}) => {
  const data = [
    { name: 'active', value: percentage },
    { name: 'remaining', value: 100 - percentage },
  ];

  return (
    <div className="flex flex-col items-center">
      <div className="relative" style={{ width: size, height: size }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              innerRadius="65%"
              outerRadius="100%"
              dataKey="value"
              startAngle={90}
              endAngle={-270}
              stroke="none"
            >
              <Cell key="filled" fill={color} />
              <Cell key="empty" fill={backgroundColor} />
            </Pie>
          </PieChart>
        </ResponsiveContainer>

        <div className="absolute inset-0 flex items-center justify-center text-blueDeep font-bold text-sm">
          {percentage.toFixed(1)}%
        </div>
      </div>
      {label && <p className="text-sm mt-2 text-blueDeep">{label}</p>}
    </div>
  );
};

export default ProgressDonutChart;
